const featureTicket = process.env.appConfig["featureTicket"];
const singleHost = process.env.appConfig["api.singlehost"];

const host = process.env.appConfig["api.host"].replace("{ticket}", featureTicket);
exports.host = host;
